import { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { FiMail, FiLock, FiAlertCircle } from 'react-icons/fi';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, isLoading, error, clearError } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearError();
    try {
      await login(email, password);
      navigate('/');
    } catch {
      // Error handled in store
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container card animate-scale-in">
        <div className="auth-header">
          <h1 className="text-gradient glow-text">Match-3 Puzzle</h1>
          <p>С возвращением! Войдите, чтобы продолжить</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="error-message">
              <FiAlertCircle />
              <span>{error}</span>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">
              <FiMail /> Электронная почта
            </label>
            <input
              id="email"
              type="email"
              className="input"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <FiLock /> Пароль
            </label>
            <input
              id="password"
              type="password"
              className="input"
              placeholder="Введите пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
            {isLoading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Нет аккаунта? <Link to="/register">Зарегистрироваться</Link></p>
        </div>
      </div>

      <style>{`
        .auth-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: var(--spacing-lg);
        }
        .auth-container {
          width: 100%;
          max-width: 420px;
          padding: var(--spacing-2xl);
        }
        .auth-header {
          text-align: center;
          margin-bottom: var(--spacing-xl);
        }
        .auth-header h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: var(--spacing-sm);
        }
        .auth-header p {
          color: var(--text-secondary);
        }
        .auth-form {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-lg);
        }
        .form-group {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-sm);
        }
        .form-group label {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
          font-weight: 500;
          color: var(--text-secondary);
        }
        .btn-block {
          width: 100%;
          padding: var(--spacing-md);
        }
        .error-message {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
          padding: var(--spacing-md);
          background: rgba(255, 46, 99, 0.1);
          border: 1px solid var(--neon-pink);
          border-radius: var(--radius-md);
          color: var(--neon-pink);
        }
        .auth-footer {
          text-align: center;
          margin-top: var(--spacing-xl);
          color: var(--text-secondary);
        }
        .auth-footer a {
          color: var(--neon-blue);
          text-decoration: none;
          font-weight: 600;
        }
        .auth-footer a:hover {
          text-decoration: underline;
        }
        @media (max-width: 480px) {
          .auth-container {
            padding: var(--spacing-lg);
          }
          .auth-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default LoginPage;
